'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { createSelector } from 'reselect';

const getCodemirrorSession = state => state.codemirrorSession;

export const getCodemirrorEditorsSorted = state => getCodemirrorSession(state).sortedEditors;

const getCodemirrorEditors = state => getCodemirrorSession(state).editors;

const getSessionId = (state, props) => props.sessionId;

export const getCodemirrorOptions = state => state.codemirrorOptions;
/**
 * Required Props;
 * - sessionId
 */

export const getCodemirrorEditorSessionBySessionId = createSelector([getSessionId, getCodemirrorEditors], (sessionId, codemirrorSessions) => codemirrorSessions && codemirrorSessions[sessionId]);
/**
 * required props: sessionId
 */

export const makeGetCodemirrorHistory = () => {
  return createSelector([getCodemirrorEditorSessionBySessionId], session => {
    if (session && session.history) {
      return SeamlessImmutable.isImmutable(session.history) ? session.history.asMutable() : session.history;
    }

    return null;
  });
};
export const makeGetHistorySize = () => {
  return createSelector([getCodemirrorEditorSessionBySessionId], session => session && session.historySize);
};
export const makeGetCodemirrorSelections = () => {
  return createSelector([getCodemirrorEditorSessionBySessionId], session => session && session.selections);
};